import React, {useState, useEffect} from "react";
import {ListFacilitatorsService, UpdateFacilitatorService} from "../services/FacilitatorsService";

export const FacilitatorsContext = React.createContext({});

export default function FacilitatorsProvider({children}) {
   const [completeList, setList] = useState([]);
   const [wineList, setWine] = useState([]);
   const [barList, setBar] = useState([]);
   const [visibleList, setVisibles] = useState([]);
   const [isLoading, setLoading] = useState({wine: true, bar: true, visibles: true});

   useEffect(() => {
      // llamar a todos los facilitadores
      getFacilitators();
   }, []);

   useEffect(() => {
      getVisibles();
   }, [completeList]);
   useEffect(() => {
      getWineList();
      getBarList();
   }, [visibleList]);

   function getFacilitators() {
      ListFacilitatorsService()
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            let newList = data.map((item) => {
               return {...item, name: item.facilitatorName + " " + item.facilitatorLastName};
            });
            setList([...newList]);
         })
         .catch((e) => {
            console.log(e);
         });
   }

   function getWineList() {
      const listWine = visibleList.filter((item) => item.facilitatorArea === "Vino");
      setWine(listWine);
      setLoading({...isLoading, wine: false, bar: false});
   }

   function getBarList() {
      const listBar = visibleList.filter((item) => item.facilitatorArea === "Barra");
      setBar(listBar);
      setLoading({...isLoading, bar: false, wine: false});
   }

   function getVisibles() {
      const listVisible = completeList.filter((item) => item.isActive === 1);
      setVisibles(listVisible);
      setLoading({...isLoading, visibles: false});
   }

   function addFacilitator(newF) {
      // se agrega a la lista general
      // como use effecto detectan actualizaciones en esa lista en automatico
      // las otras listas de actualzizan
      let currentL = completeList;
      const newList = [...currentL, {...newF}];
      setList(newList);
   }

   function toggleChange(data) {
      // recibe el item completo y de ahí toma los valores que necesita
      // solo hace un togle 1 - 0
      let newData = {...data, addToWeb: data.addToWeb ? 0 : 1};

      let currentL = completeList;
      let newList = currentL.map((item) => {
         if (data.idFacilitator === item.idFacilitator) return newData;
         return item;
      });
      setList(newList);
      /* 
      let tosend = new FormData();
      tosend.append("token", localStorage.getItem("domecq_token"));
      tosend.append("idFacilitator", newData.idFacilitator);
      tosend.append("idFacilitatorArea", newData.facilitatorArea);
      tosend.append("facilitatorName", newData.facilitatorName);
      tosend.append("facilitatorLastName", newData.facilitatorLastName);
      tosend.append("biography", newData.biography);
      tosend.append("shortDescription", newData.shortDescription);
      tosend.append("phone", newData.phone);
      tosend.append("addToWeb", newData.addToWeb);

      UpdateFacilitatorService(tosend)
         .then(res => res.json())
         .then(resp => {
            const {data, data2, status} = resp;
            console.log(resp);
            if (status === "error") throw new Error();
            // addFacilitator(newFacilitator);
         })
         .catch(e => {
            console.log(e);
         });
      */
   }

   function removeFacilitator(data) {
      const newList = completeList.filter((item) => item.idFacilitator !== data.id);
      setList(newList);
   }

   return (
      <FacilitatorsContext.Provider
         value={{
            wineList: wineList, // list de vino
            getWineList: getWineList, // obtener lista de vino
            isLoading, // garando algun dato
            getBarList, // obtener lista de barra
            barList, // lista de barra
            addFacilitator, // agregar fácilitador
            toggleChange, // visible en página
            removeFacilitator, // hacer no visible
            visibleList, // lista de facilitadores visibles
         }}
      >
         {children}
      </FacilitatorsContext.Provider>
   );
}
